import { createContext, useContext, useEffect, useState } from "react";
import { getLocalStorage } from "../helpers/browserStorage";
import { usePopup } from "./PopupContext";
import Loading from "../components/Loading";
import useUser from "../hooks/pages/useUser";
import { useMutation } from "react-query";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

function AuthProvider({ children }) {
  const [user, setUser] = useState({});
  const [accessToken, setAccessToken] = useState(
    getLocalStorage("accessToken")
  );
  // const [organizationId, setOrganizationId] = useState(
  //   getLocalStorage("organizationId")
  // );
  // const [isOwner, setIsOwner] = useState(false);

  // const [pageId, setPageId] = useState(getLocalStorage("pageId"));

  const { toast } = usePopup();

  const { getProfile } = useUser();

  const { mutate: fetchProfile, isLoading: isProfileLoading } = useMutation({
    mutationFn: getProfile,
    onSuccess: (res) => {
      setUser(res?.data?.user);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || "Unable to get your profile!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (accessToken) {
      fetchProfile();
    }
  }, [accessToken]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        accessToken,
        setAccessToken,
        fetchProfile,
        isProfileLoading,
        // organizationId,
        // setOrganizationId,
        // isOwner,
        // setIsOwner,
        // pageId,
        // setPageId,
      }}
    >
      {isProfileLoading ? <FetchingUserDetails /> : children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;

function FetchingUserDetails() {
  return (
    <div className="w-screen h-screen text-gray-500 flex flex-col space-y-4 justify-center items-center ">
      <div className="text-2xl">Fetching your details...please wait</div>
      <Loading />
    </div>
  );
}
